import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, vModelSelect as _vModelSelect, withKeys as _withKeys, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-1 text-sm text-gray-400" }
const _hoisted_4 = { class: "flex items-center space-x-4" }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = { class: "flex rounded-lg border border-gray-700 bg-dark-secondary p-1" }
const _hoisted_7 = ["onClick", "title"]
const _hoisted_8 = { class: "w-[104px]" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "h-5 w-5 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "flex flex-col gap-4 rounded-lg border border-gray-700 bg-dark-secondary p-4" }
const _hoisted_13 = { class: "flex gap-4" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "w-64" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "flex items-center gap-3 pl-2 border-l border-gray-700" }
const _hoisted_19 = { class: "flex rounded-lg border border-gray-700 p-1" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "relative flex h-2 w-2"
}
const _hoisted_22 = { class: "flex items-center gap-3 pl-2 border-l border-gray-700" }
const _hoisted_23 = { class: "flex rounded-lg border border-gray-700 p-1" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "relative flex h-2 w-2"
}
const _hoisted_26 = { class: "flex items-center gap-4" }
const _hoisted_27 = { class: "relative tags-filter flex-1" }
const _hoisted_28 = { class: "flex flex-wrap items-center gap-2 rounded-lg border border-gray-700 bg-dark p-2 min-h-[40px] focus-within:border-primary focus-within:ring-1 focus-within:ring-primary" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "absolute left-0 right-0 top-full z-10 mt-1 max-h-48 overflow-y-auto rounded-lg border border-gray-700 bg-dark-secondary shadow-lg"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "w-48" }
const _hoisted_33 = ["value", "title"]
const _hoisted_34 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-700 pt-3"
}
const _hoisted_35 = { class: "flex items-center gap-4" }
const _hoisted_36 = { class: "text-sm text-gray-400" }
const _hoisted_37 = {
  key: 0,
  class: "flex items-center gap-3 pl-4 border-l border-gray-700"
}
const _hoisted_38 = { class: "flex items-center gap-2" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "flex items-center gap-2 pl-3 border-l border-gray-700" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "flex items-center gap-2 text-sm text-gray-400 pl-3 border-l border-gray-700"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "min-h-[200px] rounded-lg border border-gray-700 bg-dark-secondary" }
const _hoisted_49 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_50 = { class: "mt-2 text-sm font-medium text-gray-200" }
const _hoisted_51 = { class: "mt-1 text-sm text-gray-400" }
const _hoisted_52 = { class: "mt-6" }
const _hoisted_53 = ["disabled"]

import { ref, computed, onMounted, onBeforeUnmount, defineComponent } from 'vue'
import { useProductStore } from '@/stores/products'
import { useOrgStore } from '@/stores/org'
import ProductListItem from '@/components/content/ProductListItem.vue'
import RulesEngine from '@/components/rules/RulesEngine.vue'
import MetaPromptModal from '@/components/content/MetaPromptModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyBusinessView',
  setup(__props) {

const productStore = useProductStore()
const orgStore = useOrgStore()
const currentView = ref('list')
const isSaving = ref(false)

// Meta prompt modal state
const showMetaPromptModal = ref(false)
const selectedProduct = ref<any>(null)

const openMetaPromptModal = (product: any) => {
  selectedProduct.value = product
  showMetaPromptModal.value = true
}

const closeMetaPromptModal = () => {
  showMetaPromptModal.value = false
  selectedProduct.value = null
}

const saveMetaPrompt = async (metaPrompt: string) => {
  if (!selectedProduct.value) return

  try {
    await productStore.updateProduct(selectedProduct.value.id, {
      config: {
        ...selectedProduct.value.config,
        meta_prompt: metaPrompt
      }
    })
    closeMetaPromptModal()
  } catch (error) {
    console.error('Failed to save meta prompt:', error)
  }
}
const isBulkUpdating = ref(false)
const bulkPriority = ref<number | null>(null)
const updateProgress = ref({ current: 0, total: 0 })

// Filters state
// Tag search state
const tagSearchQuery = ref('')
const showTagSuggestions = ref(false)

// Close tag suggestions when clicking outside
const closeTagSuggestions = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (!target.closest('.tags-filter')) {
    showTagSuggestions.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', closeTagSuggestions)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', closeTagSuggestions)
})

// Filtered available tags based on search
const filteredAvailableTags = computed(() => {
  if (!tagSearchQuery.value) return availableTags.value
  const query = tagSearchQuery.value.toLowerCase()
  return availableTags.value.filter(
    tag => tag.toLowerCase().includes(query) && !filters.value.tags.includes(tag)
  )
})

const shopifyStatusFilters = [
  { value: 'ACTIVE', label: 'Active in Shopify' },
  { value: 'DRAFT', label: 'Draft in Shopify' },
  { value: 'ARCHIVED', label: 'Archived in Shopify' },
  { value: '', label: 'All Statuses' }
]

const filters = ref({
  search: '',
  productType: '',
  tags: [] as string[],
  status: '', // '' = all, 'active' = active only, 'inactive' = inactive only
  inventory: '', // '' = all, 'in_stock' = in stock only, 'out_of_stock' = out of stock only
  shopifyStatus: 'ACTIVE' // Default to showing active products
})

// Available filter options
const productTypes = computed(() => {
  const types = new Set(products.value
    .map(p => p.product_type)
    .filter(type => type && type.trim() !== '')
  )
  return Array.from(types).sort()
})

const availableTags = computed(() => {
  const tags = new Set(products.value.flatMap(p => p.tags || []))
  return Array.from(tags).sort()
})

const statusFilters = [
  { value: '', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
]

const inventoryFilters = [
  { value: '', label: 'All' },
  { value: 'in_stock', label: 'In Stock' },
  { value: 'out_of_stock', label: 'Out of Stock' }
]

const toggleStatusFilter = (status: string) => {
  filters.value.status = filters.value.status === status ? '' : status
}

const toggleInventoryFilter = (inventory: string) => {
  filters.value.inventory = filters.value.inventory === inventory ? '' : inventory
}

// Update hasActiveFilters computed
const hasActiveFilters = computed(() => {
  return filters.value.search || 
         filters.value.productType || 
         filters.value.tags.length > 0 ||
         filters.value.status !== '' ||
         filters.value.inventory !== ''
})

const hasUnsavedChanges = computed(() => productStore.hasUnsavedChanges)

// Filter methods
const selectTag = (tag: string) => {
  if (!filters.value.tags.includes(tag)) {
    filters.value.tags.push(tag)
  }
  tagSearchQuery.value = ''
  showTagSuggestions.value = true // Keep suggestions visible after selection
  // Keep focus on input after selection
  const input = document.querySelector('.tags-filter input') as HTMLInputElement
  if (input) {
    input.focus()
  }
}

const handleBackspace = () => {
  if (tagSearchQuery.value === '' && filters.value.tags.length > 0) {
    const lastTag = filters.value.tags[filters.value.tags.length - 1]
    toggleTag(lastTag)
  }
}

const toggleTag = (tag: string) => {
  const index = filters.value.tags.indexOf(tag)
  if (index === -1) {
    filters.value.tags.push(tag)
  } else {
    filters.value.tags.splice(index, 1)
  }
  tagSearchQuery.value = ''
  showTagSuggestions.value = true // Keep suggestions visible after removing tag
  // Keep focus on input after removing tag
  const input = document.querySelector('.tags-filter input') as HTMLInputElement
  if (input) {
    input.focus()
  }
}

const clearFilters = () => {
  filters.value = {
    search: '',
    productType: '',
    tags: [],
    status: '',
    inventory: '',
    shopifyStatus: 'ACTIVE'
  }
}

// Filtered products
const filteredProducts = computed(() => {
  let result = [...products.value]

  // Text search
  if (filters.value.search) {
    const searchLower = filters.value.search.toLowerCase()
    result = result.filter(product => 
      product.title.toLowerCase().includes(searchLower) ||
      product.product_type.toLowerCase().includes(searchLower) ||
      product.tags?.some(tag => tag.toLowerCase().includes(searchLower))
    )
  }

  // Product type filter
  if (filters.value.productType) {
    result = result.filter(product => 
      product.product_type === filters.value.productType
    )
  }

  // Tags filter
  if (filters.value.tags.length) {
    result = result.filter(product => 
      filters.value.tags.every(tag => product.tags?.includes(tag))
    )
  }

      // Status filter
  if (filters.value.status) {
    result = result.filter(product => 
      filters.value.status === 'active' ? product.config?.is_active === true : product.config?.is_active === false
    )
  }

  // Inventory filter
  if (filters.value.inventory) {
    result = result.filter(product => {
      const hasStock = (product.inventory_qty ?? 0) > 0
      return filters.value.inventory === 'in_stock' ? hasStock : !hasStock
    })
  }

  // Shopify status filter
  if (filters.value.shopifyStatus) {
    result = result.filter(product => 
      product.shopify_status === filters.value.shopifyStatus
    )
  }

  return result
})

const saveAllProducts = async () => {
  if (isSaving.value) return
  
  isSaving.value = true
  try {
    await productStore.saveAllProducts()
  } catch (error) {
    console.error('Failed to save all products:', error)
  } finally {
    isSaving.value = false
  }
}

const bulkUpdateActive = async (isActive: boolean) => {
  if (isBulkUpdating.value || !filteredProducts.value.length) return

  isBulkUpdating.value = true
  updateProgress.value = { current: 0, total: 0 }

  try {
    const productIds = filteredProducts.value.map(p => p.id)
    await productStore.batchUpdateProducts(
      productIds,
      { config: { is_active: isActive, priority: 0 } },
      (current, total) => {
        updateProgress.value = { current, total }
      }
    )
  } catch (error) {
    console.error('Failed to update product status:', error)
  } finally {
    isBulkUpdating.value = false
    updateProgress.value = { current: 0, total: 0 }
  }
}

const bulkUpdatePriority = async () => {
  if (isBulkUpdating.value || !filteredProducts.value.length || !bulkPriority.value) return

  isBulkUpdating.value = true
  updateProgress.value = { current: 0, total: 0 }

  try {
    const productIds = filteredProducts.value.map(p => p.id)
    await productStore.batchUpdateProducts(
      productIds,
      { config: { priority: bulkPriority.value, is_active: true } },
      (current, total) => {
        updateProgress.value = { current, total }
      }
    )
    bulkPriority.value = null
  } catch (error) {
    console.error('Failed to update product priority:', error)
  } finally {
    isBulkUpdating.value = false
    updateProgress.value = { current: 0, total: 0 }
  }
}

const views = [
  {
    id: 'list',
    label: 'List',
    icon: defineComponent({
      template: `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
        </svg>
      `
    })
  },
  {
    id: 'grid',
    label: 'Grid',
    icon: defineComponent({
      template: `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25a2.25 2.25 0 0 1-2.25-2.25v-2.25Z" />
        </svg>
      `
    })
  }
]

// Computed properties from store
const products = computed(() => productStore.products)
const sortedProducts = computed(() => productStore.sortedProducts)
const isSyncing = computed(() => productStore.isSyncing)
const lastSyncedText = computed(() => {
  if (!productStore.lastSyncTime) return 'Never'
  
  const diffInMinutes = Math.round((Date.now() - productStore.lastSyncTime.getTime()) / (1000 * 60))
  
  if (diffInMinutes >= 60) {
    const diffInHours = Math.round(diffInMinutes / 60)
    return new Intl.RelativeTimeFormat('en', { numeric: 'auto' }).format(-diffInHours, 'hours')
  }
  
  return new Intl.RelativeTimeFormat('en', { numeric: 'auto' }).format(-diffInMinutes, 'minutes')
})

// Methods
const syncProducts = async () => {
  try {
    const result = await productStore.syncWithShopify()
    
    // Optional: You could add a toast notification here to show the sync status
    if (result.sync_status === 'pending' || result.sync_status === 'syncing') {
      console.log('Sync in progress:', result.message)
    } else if (result.sync_status === 'completed') {
      console.log('Sync completed successfully')
    }
  } catch (error) {
    console.error('Failed to sync products:', error)
    // Optional: You could add error handling UI feedback here
  }
}

// Lifecycle
onMounted(async () => {
  await Promise.all([
    productStore.fetchProducts(),
    orgStore.watchOrgData()
  ])
})

// Cleanup subscriptions when component is unmounted
onBeforeUnmount(() => {
  if (productStore.unsubscribeSyncStatus) {
    productStore.unsubscribeSyncStatus()
    productStore.unsubscribeSyncStatus = null
  }
  orgStore.cleanup()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "text-2xl font-semibold text-gray-100" }, "Products", -1)),
        _createElementVNode("p", _hoisted_3, " Last synced: " + _toDisplayString(lastSyncedText.value), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-sm text-gray-400" }, "View:", -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(views, (view) => {
              return _createElementVNode("button", {
                key: view.id,
                onClick: ($event: any) => (currentView.value = view.id),
                class: _normalizeClass([
                'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
                currentView.value === view.id
                  ? 'bg-primary text-white'
                  : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
              ]),
                title: view.label
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(view.icon), { class: "h-4 w-4" })),
                _createElementVNode("span", null, _toDisplayString(view.label), 1)
              ], 10, _hoisted_7)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("button", {
            onClick: saveAllProducts,
            disabled: isSaving.value,
            class: _normalizeClass(["inline-flex h-[38px] w-[104px] items-center justify-center gap-2 rounded-lg border text-sm font-medium transition-all", [
              isSaving.value
                ? 'border-gray-700 bg-gray-800 text-gray-400'
                : 'border-primary bg-primary/10 text-primary hover:bg-primary/20'
            ]])
          }, [
            (isSaving.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[10] || (_cache[10] = [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(isSaving.value ? 'Saving' : 'Save All'), 1)
          ], 10, _hoisted_9), [
            [_vShow, hasUnsavedChanges.value]
          ])
        ]),
        (!_unref(orgStore).isShopifyConnected)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/search-settings",
              class: "inline-flex items-center gap-2 rounded-lg border border-primary px-4 py-2 text-sm font-medium text-primary transition-colors hover:bg-primary/10"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  })
                ], -1),
                _createTextVNode(" Connect Shopify ")
              ])),
              _: 1,
              __: [11]
            }))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "inline-flex items-center gap-2 rounded-lg border border-gray-700 px-4 py-2 text-sm font-medium text-gray-200 transition-colors hover:border-gray-600 hover:text-white disabled:opacity-50",
              onClick: syncProducts,
              disabled: isSyncing.value || isSaving.value
            }, [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-5 w-5", { 'animate-spin': isSyncing.value }]),
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                }, null, -1)
              ]), 2)),
              _createTextVNode(" " + _toDisplayString(isSyncing.value ? 'Syncing...' : 'Sync Products'), 1)
            ], 8, _hoisted_11))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, [
              _createElementVNode("svg", {
                class: "h-5 w-5 text-gray-400",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                })
              ])
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.search) = $event)),
              type: "search",
              class: "block w-full rounded-lg border border-gray-700 bg-dark pl-10 pr-3 py-2 text-sm text-gray-100 placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary",
              placeholder: "Search products..."
            }, null, 512), [
              [_vModelText, filters.value.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.productType) = $event)),
            class: "block w-full rounded-lg border border-gray-700 bg-dark px-3 py-2 text-sm text-gray-100 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "All Product Types", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productTypes.value, (type) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type,
                value: type
              }, _toDisplayString(type), 9, _hoisted_17))
            }), 128))
          ], 512), [
            [_vModelSelect, filters.value.productType]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusFilters, (status) => {
              return _createElementVNode("button", {
                key: status.value,
                onClick: ($event: any) => (toggleStatusFilter(status.value)),
                class: _normalizeClass([
                'flex items-center gap-1.5 rounded px-2.5 py-1 text-sm font-medium transition-colors',
                filters.value.status === status.value
                  ? 'bg-primary text-white'
                  : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
              ])
              }, [
                (status.value !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                  'relative inline-flex h-2 w-2 rounded-full',
                  status.value === 'active' ? 'bg-emerald-500' : 'bg-gray-500'
                ])
                      }, null, 2)
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(status.label), 1)
              ], 10, _hoisted_20)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inventoryFilters, (inventory) => {
              return _createElementVNode("button", {
                key: inventory.value,
                onClick: ($event: any) => (toggleInventoryFilter(inventory.value)),
                class: _normalizeClass([
                'flex items-center gap-1.5 rounded px-2.5 py-1 text-sm font-medium transition-colors',
                filters.value.inventory === inventory.value
                  ? 'bg-primary text-white'
                  : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
              ])
              }, [
                (inventory.value !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                  'relative inline-flex h-2 w-2 rounded-full',
                  inventory.value === 'in_stock' ? 'bg-emerald-500' : 'bg-red-500'
                ])
                      }, null, 2)
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(inventory.label), 1)
              ], 10, _hoisted_24)
            }), 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value.tags, (tag) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tag,
                class: "inline-flex items-center gap-1 rounded-full bg-primary/20 px-2 py-1 text-xs font-medium text-primary"
              }, [
                _createTextVNode(_toDisplayString(tag) + " ", 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (toggleTag(tag)),
                  class: "text-primary/70 hover:text-primary",
                  "aria-label": "Remove tag"
                }, "×", 8, _hoisted_29)
              ]))
            }), 128)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tagSearchQuery).value = $event)),
              type: "text",
              class: "flex-1 min-w-[120px] bg-transparent text-sm text-gray-100 placeholder-gray-400 focus:outline-none",
              placeholder: "Search tags...",
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (showTagSuggestions.value = true)),
              onKeydown: _withKeys(handleBackspace, ["backspace"])
            }, null, 544), [
              [_vModelText, tagSearchQuery.value]
            ])
          ]),
          (showTagSuggestions.value && filteredAvailableTags.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAvailableTags.value, (tag) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: tag,
                    onClick: ($event: any) => (selectTag(tag)),
                    class: "w-full px-3 py-2 text-left text-sm text-gray-200 transition-colors hover:bg-gray-700/50"
                  }, _toDisplayString(tag), 9, _hoisted_31))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.shopifyStatus) = $event)),
            class: "block w-full rounded-lg border border-gray-700 bg-dark px-3 py-2 text-sm text-gray-100 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shopifyStatusFilters, (status) => {
              return _createElementVNode("option", {
                key: status.value,
                value: status.value,
                title: ['DRAFT', 'ARCHIVED'].includes(status.value) ? 'Product must be activated in Shopify' : ''
              }, _toDisplayString(status.label), 9, _hoisted_33)
            }), 64))
          ], 512), [
            [_vModelSelect, filters.value.shopifyStatus]
          ])
        ])
      ]),
      (hasActiveFilters.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, " Showing " + _toDisplayString(filteredProducts.value.length) + " of " + _toDisplayString(products.value.length) + " products ", 1),
              (filteredProducts.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (bulkUpdateActive(true))),
                        disabled: isBulkUpdating.value,
                        class: "inline-flex items-center gap-1.5 rounded-lg border border-gray-700 px-3 py-1.5 text-sm font-medium text-gray-300 hover:border-emerald-500/30 hover:bg-emerald-500/10 hover:text-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed"
                      }, _cache[15] || (_cache[15] = [
                        _createElementVNode("span", { class: "h-2 w-2 rounded-full bg-emerald-500" }, null, -1),
                        _createTextVNode(" Set All Active ")
                      ]), 8, _hoisted_39),
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (bulkUpdateActive(false))),
                        disabled: isBulkUpdating.value,
                        class: "inline-flex items-center gap-1.5 rounded-lg border border-gray-700 px-3 py-1.5 text-sm font-medium text-gray-300 hover:border-gray-500/30 hover:bg-gray-500/10 hover:text-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
                      }, _cache[16] || (_cache[16] = [
                        _createElementVNode("span", { class: "h-2 w-2 rounded-full bg-gray-500" }, null, -1),
                        _createTextVNode(" Set All Inactive ")
                      ]), 8, _hoisted_40)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bulkPriority).value = $event)),
                        type: "number",
                        min: "0",
                        class: "w-20 rounded-lg border border-gray-700 bg-dark px-2 py-1.5 text-sm text-gray-100",
                        placeholder: "Priority",
                        disabled: isBulkUpdating.value
                      }, null, 8, _hoisted_42), [
                        [_vModelText, bulkPriority.value]
                      ]),
                      _createElementVNode("button", {
                        onClick: bulkUpdatePriority,
                        disabled: isBulkUpdating.value || !bulkPriority.value,
                        class: "inline-flex items-center gap-1.5 rounded-lg border border-gray-700 px-3 py-1.5 text-sm font-medium text-gray-300 hover:border-primary/30 hover:bg-primary/10 hover:text-primary disabled:opacity-50 disabled:cursor-not-allowed"
                      }, " Set All Priority ", 8, _hoisted_43)
                    ]),
                    (isBulkUpdating.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _cache[17] || (_cache[17] = _createElementVNode("svg", {
                            class: "h-4 w-4 animate-spin",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4",
                              fill: "none"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)),
                          (updateProgress.value.total)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, " Updated " + _toDisplayString(updateProgress.value.current) + "/" + _toDisplayString(updateProgress.value.total) + " products ", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_46, " Updating " + _toDisplayString(filteredProducts.value.length) + " products... ", 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: clearFilters,
              class: "text-sm text-gray-400 hover:text-white",
              disabled: isBulkUpdating.value
            }, " Clear filters ", 8, _hoisted_47)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(RulesEngine),
    _createVNode(MetaPromptModal, {
      show: showMetaPromptModal.value,
      "meta-prompt": selectedProduct.value?.config?.meta_prompt,
      onClose: closeMetaPromptModal,
      onSave: saveMetaPrompt
    }, null, 8, ["show", "meta-prompt"]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", {
        class: _normalizeClass([
          currentView.value === 'grid'
            ? 'grid grid-cols-1 gap-6 p-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
            : 'divide-y divide-gray-700'
        ])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
          return (_openBlock(), _createBlock(ProductListItem, {
            key: product.id,
            product: product,
            "is-grid": currentView.value === 'grid',
            onEditMetaPrompt: ($event: any) => (openMetaPromptModal(product))
          }, null, 8, ["product", "is-grid", "onEditMetaPrompt"]))
        }), 128))
      ], 2),
      (!filteredProducts.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _cache[20] || (_cache[20] = _createElementVNode("svg", {
              class: "h-12 w-12 text-gray-400",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              })
            ], -1)),
            _createElementVNode("h3", _hoisted_50, _toDisplayString(products.value.length ? 'No products match your filters' : 'No products found'), 1),
            _createElementVNode("p", _hoisted_51, _toDisplayString(products.value.length 
            ? 'Try adjusting your search or filters' 
            : 'Get started by syncing your products from Shopify.'), 1),
            _createElementVNode("div", _hoisted_52, [
              (!products.value.length && !_unref(orgStore).isShopifyConnected)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/search-settings",
                    class: "inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-dark"
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                        }),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        })
                      ], -1),
                      _createTextVNode(" Connect Shopify ")
                    ])),
                    _: 1,
                    __: [18]
                  }))
                : _createCommentVNode("", true),
              (!products.value.length && _unref(orgStore).isShopifyConnected)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-dark",
                    onClick: syncProducts,
                    disabled: isSyncing.value
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["h-5 w-5", { 'animate-spin': isSyncing.value }]),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, _cache[19] || (_cache[19] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      }, null, -1)
                    ]), 2)),
                    _createTextVNode(" " + _toDisplayString(isSyncing.value ? 'Syncing...' : 'Sync Products'), 1)
                  ], 8, _hoisted_53))
                : _createCommentVNode("", true),
              (hasActiveFilters.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "text-sm text-primary hover:text-primary-light",
                    onClick: clearFilters
                  }, " Clear all filters "))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})